import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "../AppIcon";
import Button from "./Button";

const MainNavigation = ({ isCollapsed, onToggle }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    {
      label: t("dashboard"),
      path: "/dashboard",
      icon: "LayoutDashboard",
      badge: null,
      tooltip: t("overviewTooltip"),
    },
    {
      label: t("customers"),
      path: "/customer-management",
      icon: "Users",
      badge: null,
      tooltip: t("manageCustomersTooltip"),
    },
    {
      label: t("products"),
      path: "/product-catalog-management",
      icon: "Package",
      badge: null,
      tooltip: t("manageProductsTooltip"),
    },
    {
      label: t("categories"),
      path: "/category-management",
      icon: "Tags",
      badge: null,
      tooltip: t("organizeCategoriesTooltip"),
    },
    {
      label: t("orders"),
      path: "/order-management",
      icon: "ShoppingCart",
      badge: 3,
      tooltip: t("orderProcessingTooltip"),
    },
    {
      label: t("Coupon Management"),
      icon: "Ticket",
      type: "group",
      path: "/coupon-management",
    },
    {
      label: t("advertisement_management"),
      icon: "Megaphone",
      badge: null,
      path: "/advertisement-management",
    },
  /*  {
      label: t("customer_feedback"),
      icon: "Users",
      badge: null,
      path: "/customer-feedback-management",
      tooltip: t("customer_feedback"),
    },*/
    {
      label: t("store-information-management"),
      icon: "Store",
      badge: null,
      path: "/store-information-management",
    },
    {
      label: t("privacy-policy-management"),
      icon: "Shield",
      badge: null,
      path: "/privacy-policy-management",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile Overlay */}
      {!isCollapsed && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onToggle}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed left-0 top-16 h-[calc(100vh-4rem)] bg-white border-r border-border z-50 transition-layout shadow-elevation-1 ${
          isCollapsed
            ? "-translate-x-full lg:translate-x-0 lg:w-16"
            : "w-60 lg:w-60"
        }`}
      >
        <nav className="h-full flex flex-col">
          {/* Navigation Items */}
          <div className="flex-1 py-4">
            <ul className="space-y-1 px-3">
              {navigationItems.map((item) => {
                const isActive = isActiveRoute(item.path);

                return (
                  <li key={item.path}>
                    <Button
                      variant={isActive ? "default" : "ghost"}
                      onClick={() => handleNavigation(item.path)}
                      className={`w-full justify-start transition-micro ${
                        isCollapsed && "lg:justify-center lg:px-2"
                      } ${
                        isActive
                          ? "bg-primary text-primary-foreground shadow-elevation-1"
                          : "text-foreground hover:bg-muted hover-scale"
                      }`}
                      title={isCollapsed ? item.tooltip : ""}
                    >
                      <Icon
                        name={item.icon}
                        size={20}
                        className={`${!isCollapsed ? "mr-3" : ""}`}
                      />

                      {!isCollapsed && (
                        <>
                          <span className="flex-1 text-left font-medium">
                            {item.label}
                          </span>
                          {item.badge && (
                            <span className="ml-auto bg-error text-error-foreground text-xs px-2 py-1 rounded-full min-w-[20px] text-center">
                              {item.badge}
                            </span>
                          )}
                        </>
                      )}

                      {isCollapsed && item.badge && (
                        <span className="absolute -top-1 -right-1 w-2 h-2 bg-error rounded-full"></span>
                      )}
                    </Button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Collapse Toggle - Desktop Only */}
          <div className="hidden lg:block p-3 border-t border-border">
            <Button
              variant="ghost"
              onClick={onToggle}
              className={`w-full transition-micro hover-scale ${
                isCollapsed ? "justify-center px-2" : "justify-start"
              }`}
              title={isCollapsed ? t("expandSidebar") : t("collapseSidebar")}
            >
              <Icon
                name={isCollapsed ? "ChevronRight" : "ChevronLeft"}
                size={20}
                className={!isCollapsed ? "mr-3" : ""}
              />
              {!isCollapsed && (
                <span className="font-medium">{t("collapseSidebar")}</span>
              )}
            </Button>
          </div>
        </nav>
      </aside>
    </>
  );
};

export default MainNavigation;
